import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useTheme } from '../../theme-context';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { IPaginationPayload } from '../../interfaces/shared/IPaginationPayload';
import { tryToFetchActivities } from '../../store/brokers/partners/activities/activititesSlice';
import Input from '../../shared/input';


const ActivitiesTable = () => {
    const dispatch = useAppDispatch();
    const { theme } = useTheme();
    const [rows, setRows] = useState<any[]>([]);
    const [search, setSearch] = useState<string>();
    // const [sort, setSort] = useState<any>();
    const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
    const paginationData = useAppSelector((state) => state.activities?.activities?.data?.page);
    // const rowsLoading = useAppSelector((state) => state.teams?.membersAreLoading);
    const state = useAppSelector((state) => state.activities);

    useEffect(() => {
        if (state.activities) {
            const rows =
                state.activities?.data?.elements && Array.isArray(state.activities?.data.elements)
                    ? state.activities?.data.elements.map((r) => ({ ...r, id: r._id }))
                    : [];
            setRows(rows);
        }
    }, [state.activities]);

    const onResetPaginationState = () => {
        setPaginationState({
            pageNumber: 1,
            pageSize: paginationState?.pageSize || 10,
        })
    }

    useEffect(() => {
        const settingsFilters: any = {
            ...paginationState
        }
        if (search) {
            settingsFilters.filters = search
        }
        // if (selectedStatus && selectedStatus?.value !== 'all') {
        //     settingsFilters.data = {
        //         status: selectedStatus?.value
        //     }
        // }
        // if (sort) {
        //     settingsFilters.data = {
        //         ...settingsFilters?.data || {},
        //         sortBy: [{ key: 'name', val: sort }]
        //     }
        // }
        dispatch(tryToFetchActivities(settingsFilters));
    }, [paginationState]);

    const onChangeSearchValue = (value: string | null | undefined, type: string) => {
        setSearch(value || undefined)
        onResetPaginationState()
    }

    // const onClickSort = () => {
    //     if (sort) {
    //         setSort(sort === 'asc' ? 'desc' : 'asc')
    //     } else {
    //         setSort('asc')
    //     }
    //     onResetPaginationState()
    // }

    const formatStatus = (status: string) => {
        if (status === 'upload') {
            return <div className="flex items-center space-x-2">
                <span className={`h-2.5 w-2.5 rounded-full bg-[#039855]`}></span>
                <p className='text-[#039855] font-normal'>Upload</p>
            </div>
        }
        if (status === 'download') {
            return <div className="flex items-center space-x-2">
                <span className={`h-2.5 w-2.5 rounded-full bg-[#535862]`}></span>
                <p className='text-[#535862] font-normal'>Download</p>
            </div>
        }
    }

    // const onClickShowFilters = () => {
    //     setShowFilters(!showFilters)
    // }

    return (
        <div className=''>
            <div className='my-5 px-3 py-1 bg-[#F7F9FB] dark:bg-black flex flex-row justify-between items-center'>
                <div className='flex flex-row item-center'>
                    {/* <div className='cursor-pointer mr-2 hover:opacity-80'>
                        <img src={'/assets/navigation-icons/sidebar/add-icon.svg'} className='object-contain w-[18px]' />
                    </div> */}
                    {/* <div className='cursor-pointer mr-2 hover:opacity-80' onClick={onClickShowFilters}>
                        <img src={theme === 'dark' ? '/assets/insights/filters-icon-white.svg' : '/assets/insights/filters-icon.svg'} className='object-contain w-[20px]' />
                    </div> */}
                    {/* <div className='cursor-pointer mr-2 hover:opacity-80' onClick={onClickSort}>
                        <img src={theme === 'dark' ? '/assets/insights/sort-icon-white.svg' : '/assets/insights/sort-icon.svg'} className='object-contain w-[20px]' />
                    </div> */}
                </div>
                <div>
                    <Input
                        placeholder={'Search'}
                        containerStyle='mb-0 pb-0 relative dark:bg-bgColor-darkMode'
                        inputStyle={`mb-0 border-0 focus:outline-none dark:bg-bgColor-darkMode dark:text-primary-dark`}
                        icon={theme === 'dark' ? '/assets/navigation-icons/sidebar/search-icon-white.svg' : '/assets/shared/search.svg'}
                        showValue={true}
                        inputValue={search}
                        inputUniqueName={'search'}
                        onChangeInput={onChangeSearchValue}
                        hideInputSpace={true}
                    />
                </div>
            </div>
            {/* {showFilters &&
                <div className='grid grid-cols-1 lg:grid-cols-3 gap-4'>
                    <SelectCheckbox
                        name='Member Status'
                        dataQa={'select-status'}
                        containerStyle='mb-1 min-w-full'
                        selectedOption={selectedStatus}
                        onChangeSelectedOption={(e) => onChangeStatus?.(e)}
                        options={MEMBER_STATUS || []}
                    />
                </div>
            } */}
        <div className='overflow-x-auto max-h-[520px] overflow-y-auto'>
                <table className='min-w-full bg-white dark:bg-black dark:text-primary-dark'>
                    <thead className='bg-[#FAFAFA] dark:bg-[#3a3a3a] text-left text-sm font-medium text-black dark:text-primary-dark'>
                        <tr>
                            <th className='px-4 py-3'>File Name</th>
                            <th className='px-4 py-3'>Hotel</th>
                            <th className='px-4 py-3'>Created By</th>
                            <th className='px-4 py-3'>Date</th>
                            <th className='px-4 py-3'>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows?.map((row) => (
                            <tr key={row.id} className='border-b hover:bg-gray-50 dark:hover:bg-bgColor-darkMode text-sm'>
                                <td className='px-4 py-4 '>
                                    <div className='flex items-center'>
                                        {row?.imageUrl && <img src={row?.imageUrl || '/assets/default-avatar.png'} alt={row?.name} className='w-8 h-8 rounded-full' />}
                                        <span className='ml-3 font-medium'>{row?.name}</span>
                                    </div>
                                </td>
                                <td className='px-4 py-4'>{row?.hotelInfo?.username}</td>
                                <td className='px-4 py-4'>{row?.createdBy?.username}</td>
                                <td className='px-4 py-4'>
                                    <div className='flex items-center text-gray-600 dark:text-primary-dark'>
                                        <img src={theme === 'dark' ? '/assets/team/calendar-icon-white.svg' : '/assets/team/calendar-icon.svg'} className='w-4 h-4 mr-1' alt='' />
                                        {moment(row?.createdAt).fromNow()}
                                    </div>
                                </td>
                                <td className='px-4 py-4'>
                                    {formatStatus(row?.fileType)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div className='flex justify-between items-center bg-[#F0F0F0] dark:bg-[#3a3a3a] text-sm text-[#8F8F8F] dark:text-primary-dark px-5 py-2 mt-1 border-t border-[#DCDCDD]'>
                    <div>
                        {(paginationData && paginationData?.totalElements > 0) && (
                            <span>
                                {1 + ((paginationData?.number - 1) * paginationData?.size)}–
                                {Math.min(paginationData?.number * paginationData?.size, paginationData?.totalElements)} of {paginationData?.totalElements} items
                            </span>
                        )}
                    </div>
                    <div className='flex gap-2 items-center'>
                        <button
                            disabled={paginationData && paginationData?.number <= 1}
                            onClick={() =>
                                setPaginationState({
                                    ...paginationState,
                                    pageNumber: paginationData ? paginationData.number - 1 : 1,
                                })
                            }
                            className='hover:bg-gray-300 dark:hover:bg-black cursor-pointer px-2 py-1 rounded disabled:opacity-50'
                        >
                            ◀
                        </button>
                        <span>
                            Page {paginationData ? paginationData.number : 0} of {paginationData ? paginationData?.totalPages : 0}
                        </span>
                        <button
                            disabled={!paginationData?.hasNextPage}
                            onClick={() =>
                                setPaginationState({
                                    ...paginationState,
                                    pageNumber: paginationData ? paginationData.number + 1 : 1,
                                })
                            }
                            className='hover:bg-gray-300 dark:hover:bg-black cursor-pointer px-2 py-1 rounded disabled:opacity-50'
                        >
                            ▶
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ActivitiesTable;
